'use strict';

var React = require('react'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ZineItem = require('../organisms/ZineItem'),
    UserItem = require('../organisms/UserItem'),
    Container = require('../organisms/Container'),
    Link = require('../atoms/Link'),
    pluralize = require('../utils/pluralize'),
    SidebarTypes = require('../constants/SidebarTypes'),
    SidebarActionCreators = require('../actions/SidebarActionCreators'),
    formatDate = require('../utils/formatDate'),
    createAnalyticsContextMixin = require('../mixins/createAnalyticsContextMixin'),
    OffsetMonitor = require('../atoms/OffsetMonitor'),
    AnalyticsSources = require('../constants/AnalyticsSources'),
    Button = require('../atoms/Button'),
    ScreenSizeMixin = require('../mixins/ScreenSizeMixin'),
    ShareTypes = require('../constants/ShareTypes'),
    LikeButton = require('../molecules/LikeButton'),
    ShareAddStamp = require('../organisms/ShareAddStamp'),
    { PropTypes } = React;

require('./legacy/Stamp.less');
require('./InfoPanel.less');

var InfoPanel = React.createClass({
  mixins: [PureRenderMixin, createAnalyticsContextMixin(AnalyticsSources.INFO_PANEL), ScreenSizeMixin],

  propTypes: {
    onOffsetTopChange: PropTypes.func,
    stamp: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    primaryZine: PropTypes.object,
    otherZines: PropTypes.array.isRequired,
    isInViewer: PropTypes.bool.isRequired,
    showFeedback: PropTypes.bool,
    disableInfoPanel: PropTypes.bool
  },

  render: function () {
    const { stamp, user, primaryZine, otherZines, isInViewer, showFeedback, disableInfoPanel } = this.props;
    const { isMobile } = this.state;
    const published = stamp.published ? new Date(stamp.published) : new Date();
    const primaryServices = isMobile ? [] : [ShareTypes.FACEBOOK, ShareTypes.TWITTER];

    return (
      <OffsetMonitor onOffsetTopChange={this.props.onOffsetTopChange}>
        <div className='InfoPanel'
             data-section='info'
             data-disabled={disableInfoPanel}
             data-scroll-anchor>

          <Container context='InfoPanel'>
            <div className='InfoPanel-box'>
              {showFeedback &&
                <div className='InfoPanel-section InfoPanel-section--feedback'>
                  <Button color='green'
                          onClick={this.handleFeedbackClick}
                          active>Leave Feedback
                  </Button>
                </div>
              }

              {!showFeedback &&
                <div className='InfoPanel-section InfoPanel-section--buttons'>
                  <div className='InfoPanel-buttons'>
                    <LikeButton size='xlarge'
                                iconSize='medium'
                                showCounter={true}
                                showLikers={isInViewer}
                                stamp={stamp}
                                color='gray'
                                fill
                                like />
                    <div className='InfoPanel-share'>
                      <ShareAddStamp size='medium'
                                     color='gray'
                                     stamp={stamp}
                                     primaryServices={primaryServices}
                                     showAddLabel
                                     round />
                    </div>
                  </div>
                </div>
              }
            </div>
          </Container>

          <Container context='InfoPanel'>
            <div className='InfoPanel-box'>
              <div className='InfoPanel-section InfoPanel-section--userAndZine'>
                <div className='InfoPanel-user'>
                  <div className='InfoPanel-label utils--smallCaps'>Posted By</div>
                    <UserItem user={user}
                              vertical
                              context='InfoPanel'
                              size='small'
                              imageSize='large'
                              card
                              showAbout
                              showLocation
                              showWebsite
                              showFollow />
                    <div className='InfoPanel-date'>
                      Posted on {formatDate(published)}
                    </div>
                </div>

                {primaryZine &&
                  <div className='InfoPanel-zine'>
                    <div className='InfoPanel-label utils--smallCaps'>
                      In Collection
                    </div>

                    <ZineItem zine={primaryZine}
                              size='small'
                              context='InfoPanel' />

                    <div className='InfoPanel-otherZines'>
                      {otherZines.length > 0 &&
                        <span>
                          Also in
                          {' '}
                          <Link onClick={this.handleOtherZinesClick}
                                underline='hover'
                                bold>
                            {otherZines.length} other {pluralize(otherZines.length, 'collection', 'collections')}
                          </Link>
                        </span>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>

          </Container>
        </div>
      </OffsetMonitor>
    );
  },

  handleFeedbackClick() {
    SidebarActionCreators.showSidebar(SidebarTypes.LEAVE_DRAFT_FEEDBACK, {
      draftUuid: this.props.stamp.uuid
    });
  },

  handleOtherZinesClick() {
    SidebarActionCreators.showSidebar(SidebarTypes.STAMP_OTHER_ZINES, {
      stampId: this.props.stamp.id,
      zineSlugs: this.props.otherZines.map(z => z.slug)
    });
  }
});

module.exports = InfoPanel;



/** WEBPACK FOOTER **
 ** ./stamp/InfoPanel.jsx
 **/